var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E1E6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 13.75H23.9375V13.1875C23.9375 13.0383 23.8782 12.8952 23.7727 12.7898C23.6673 12.6843 23.5242 12.625 23.375 12.625C23.2258 12.625 23.0827 12.6843 22.9773 12.7898C22.8718 12.8952 22.8125 13.0383 22.8125 13.1875V13.75H17.1875V13.1875C17.1875 13.0383 17.1282 12.8952 17.0227 12.7898C16.9173 12.6843 16.7742 12.625 16.625 12.625C16.4758 12.625 16.3327 12.6843 16.2273 12.7898C16.1218 12.8952 16.0625 13.0383 16.0625 13.1875V13.75H14.375C14.0766 13.75 13.7905 13.8685 13.5795 14.0795C13.3685 14.2905 13.25 14.5766 13.25 14.875V26.125C13.25 26.4234 13.3685 26.7095 13.5795 26.9205C13.7905 27.1315 14.0766 27.25 14.375 27.25H25.625C25.9234 27.25 26.2095 27.1315 26.4205 26.9205C26.6315 26.7095 26.75 26.4234 26.75 26.125V14.875C26.75 14.5766 26.6315 14.2905 26.4205 14.0795C26.2095 13.8685 25.9234 13.75 25.625 13.75ZM16.0625 14.875V15.4375C16.0625 15.5867 16.1218 15.7298 16.2273 15.8352C16.3327 15.9407 16.4758 16 16.625 16C16.7742 16 16.9173 15.9407 17.0227 15.8352C17.1282 15.7298 17.1875 15.5867 17.1875 15.4375V14.875H22.8125V15.4375C22.8125 15.5867 22.8718 15.7298 22.9773 15.8352C23.0827 15.9407 23.2258 16 23.375 16C23.5242 16 23.6673 15.9407 23.7727 15.8352C23.8782 15.7298 23.9375 15.5867 23.9375 15.4375V14.875H25.625V17.125H14.375V14.875H16.0625ZM25.625 26.125H14.375V18.25H25.625V26.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/Date.4a4324ed533c5afa25f74d2011b32ea0.svg";
export { ForwardRef as ReactComponent };